var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormComponent',{attrs:{"dialog":_vm.dialog,"config":_vm.config,"valid":_vm.valid},on:{"save:form":_vm.saveConfig,"update:dialog":function($event){_vm.dialog = $event},"update:valid":function($event){_vm.valid = $event},"load:init-data":_vm.handleInitData,"clear:form":function($event){return _vm.clear($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }